import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const ItHealthCheckRoute: Route = {
  path: 'ithealthcheck',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/ithealthcheck.component').then((m) => m.IthealthcheckComponent),
    },
    {
      path: ':type',
      loadComponent: () => import('./pages/ithealthcheck-detail.component').then((m) => m.IthealthcheckDetailComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
